import { render, staticRenderFns } from "./EnrollmentCard.vue?vue&type=template&id=31caf370&scoped=true"
import script from "./EnrollmentCard.vue?vue&type=script&lang=js"
export * from "./EnrollmentCard.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentCard.vue?vue&type=style&index=0&id=31caf370&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31caf370",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VSpacer})
